import React, { useState } from "react";
import "../assets/CurrentScheme.css";

const CurrentAccountScheme = () => {
  const [formData, setFormData] = useState({
    accountName: "",
    accountNumber: "",
    schemeName: "",
    branchCode: "",
    eligibility: "",
    minBalance: "",
    overdraft: false,
    charges: "",
    chequeFacility: true,
    cashLimit: "",
    remarks: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Current Account Scheme Submitted:", formData);
    alert("✅ Current Account Scheme saved successfully!");
  };

  return (
    <div className="currentScheme-container">
      <h2>🏦 Current Account Scheme</h2>
      <form onSubmit={handleSubmit} className="currentScheme-form">
        
        {/* Account Details */}
        <div className="currentScheme-formGroup">
          <label>Account Name</label>
          <input
            type="text"
            name="accountName"
            value={formData.accountName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="currentScheme-formGroup">
          <label>Account Number</label>
          <input
            type="text"
            name="accountNumber"
            value={formData.accountNumber}
            onChange={handleChange}
            required
          />
        </div>

        <div className="currentScheme-formGroup">
          <label>Scheme Name</label>
          <input
            type="text"
            name="schemeName"
            value={formData.schemeName}
            onChange={handleChange}
          />
        </div>

        <div className="currentScheme-formGroup">
          <label>Branch Code</label>
          <input
            type="text"
            name="branchCode"
            value={formData.branchCode}
            onChange={handleChange}
          />
        </div>

        {/* Eligibility */}
        <div className="currentScheme-formGroup">
          <label>Eligibility</label>
          <select name="eligibility" value={formData.eligibility} onChange={handleChange}>
            <option value="">-- Select --</option>
            <option value="Individual">Individual</option>
            <option value="Firm">Firm</option>
            <option value="Company">Company</option>
            <option value="Trust">Trust</option>
            <option value="Society">Society</option>
          </select>
        </div>

        {/* Minimum Balance */}
        <div className="currentScheme-formGroup">
          <label>Minimum Balance Requirement (₹)</label>
          <input
            type="number"
            name="minBalance"
            value={formData.minBalance}
            onChange={handleChange}
          />
        </div>

        {/* Overdraft */}
        <div className="currentScheme-formGroup currentScheme-checkbox">
          <label>
            <input
              type="checkbox"
              name="overdraft"
              checked={formData.overdraft}
              onChange={handleChange}
            />
            Overdraft Facility Available
          </label>
        </div>

        {/* Charges */}
        <div className="currentScheme-formGroup">
          <label>Charges & Fees</label>
          <textarea
            name="charges"
            value={formData.charges}
            onChange={handleChange}
            placeholder="e.g. Non-maintenance charges ₹500, Cheque bounce charges ₹250"
          />
        </div>

        {/* Cheque Facility */}
        <div className="currentScheme-formGroup currentScheme-checkbox">
          <label>
            <input
              type="checkbox"
              name="chequeFacility"
              checked={formData.chequeFacility}
              onChange={handleChange}
            />
            Cheque Book Facility
          </label>
        </div>

        {/* Cash Limit */}
        <div className="currentScheme-formGroup">
          <label>Cash Deposit / Withdrawal Limit (per month)</label>
          <input
            type="text"
            name="cashLimit"
            value={formData.cashLimit}
            onChange={handleChange}
          />
        </div>

        {/* Remarks */}
        <div className="currentScheme-formGroup">
          <label>Remarks / Notes</label>
          <textarea
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="currentScheme-submitBtn">Save Scheme</button>
      </form>
    </div>
  );
};

export default CurrentAccountScheme;
